import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core'; // Importera ngx-translate

@Component({
    selector: 'ngbd-error-modal',
    template: `
    <div class="modal-header">
      <p class="modal-title">{{ title }}</p>
    </div>
    <div class="modal-body box">
      <fa-icon [icon]="['far', 'frown']" class="me-3" size="3x"></fa-icon>
      <p class="text-justify ms-3 me-3 mb-0" style="font-size: 1.1em; line-height: 175%; white-space: pre-line; overflow-wrap: anywhere;">
        {{ ( message || unknownError ) }}
      </p>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn-garanti btn-white" (click)="close()" autofocus>{{ closeText }}</button>
    </div>
  `,
    styles: [`
    .modal-body {
      margin: 0 !important;
    }

    .btn-white:hover:not(:disabled) {
      color: var(--lh-error);
    }
  `],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NgbdErrorModal {
  @Input() public title: string;
  @Input() public message: string;
  @Input() public buttonCallback: () => void;

  public closeText: string;
  public unknownError: string;

  constructor(
    public activeModal: NgbActiveModal,
    private translate: TranslateService
  ) {
    this.translate.get('modal.close').subscribe((res: string) => this.closeText = res);
    this.translate.get('modal.unknown-error').subscribe((res: string) => this.unknownError = res);
  }

  public close(): void {
    this.activeModal.close();

    if (this.buttonCallback) this.buttonCallback();
  }
}
